import { createClient } from '@supabase/supabase-js';

const APPROVED_SUPABASE_HOST = 'ekccbxxpzjxkrrxcjlou.supabase.co';

export const supabaseUrl =
    import.meta.env.VITE_SUPABASE_URL ||
    import.meta.env.NEXT_PUBLIC_SUPABASE_URL ||
    import.meta.env.SUPABASE_URL;

export const supabaseAnonKey =
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
    import.meta.env.SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
}

try {
    const configuredHost = new URL(supabaseUrl).host;
    if (configuredHost !== APPROVED_SUPABASE_HOST) {
        throw new Error(`Unexpected Supabase project: ${configuredHost}`);
    }
} catch (error) {
    console.error('[Supabase] Refusing to initialize with wrong project URL:', supabaseUrl, error);
    throw error;
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
